import React from 'react';
import { useNavigate } from 'react-router-dom';

import Tooltip from 'components/shared/tooltip';

import InfobookIcon from './InfobookIcon';

const IconColumnOne = () => {
  const navigate = useNavigate();

  return (
    <div className="icon-column">
      <Tooltip content="Click to learn HTML">
        <InfobookIcon
          itemText="HTML"
          iconName="IoLogoHtml5"
          onClick={() => navigate('/infobook/html')}
        />
      </Tooltip>
      <Tooltip content="Click to learn CSS">
        <InfobookIcon
          itemText="CSS"
          iconName="IoLogoCss3"
          onClick={() => navigate('/infobook/css')}
        />
      </Tooltip>
      <Tooltip content="Click to learn JavaScript">
        <InfobookIcon
          itemText="JavaScript"
          iconName="IoLogoJavascript"
          onClick={() => navigate('/infobook/javascript')}
        />
      </Tooltip>
    </div>
  );
};

export default IconColumnOne;
